module.exports = __webpack_public_path__ + "img/stu1.434a496d.png";